(function ($, Drupal) {

  Drupal.behaviors.accordionInit = {
    attach(context, settings) {
      $(document).ready(function () {

        const accordionItem = $('.accordion-item__wrapper');
        
        accordionItem.on('click', function(event) {

          event.stopImmediatePropagation();
          
          if ($(this).parent().hasClass('active')) {
            $(this).parent().removeClass('active');
          } else {
            $(this).parent().addClass('active');
          }  
        });

      });
    },
  };

}(jQuery, Drupal));